import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { SASSInfo } from './SASSInfo';
import { VideoSection } from './VideoSection';
import { Gallery } from './Gallery';
import { QuickLinks } from './QuickLinks';
export function CowboyActionPage() {
  return <PageLayout data-id="element-892">
      <HeaderBanner data-id="element-893" />
      <SASSInfo data-id="element-894" />
      <VideoSection data-id="element-895" />
      <Gallery data-id="element-896" />
      <QuickLinks data-id="element-897" />
    </PageLayout>;
}